import { render, staticRenderFns } from "./tui-image-editor.vue?vue&type=template&id=4c728384&scoped=true&"
import script from "./tui-image-editor.vue?vue&type=script&lang=js&"
export * from "./tui-image-editor.vue?vue&type=script&lang=js&"
import style0 from "./tui-image-editor.vue?vue&type=style&index=0&id=4c728384&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c728384",
  null
  
)

export default component.exports